import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { Card } from '../ui/Card';
type QuickActionCardProps = {
  icon: string;
  label: string;
  onClick: () => void;
  delay?: number;
};
export function QuickActionCard({
  icon,
  label,
  onClick,
  delay = 0
}: QuickActionCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay
  }} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-151">
      <Card className="p-6 cursor-pointer group transition-all duration-200 hover:shadow-md hover:border-teal-deep/30" onClick={onClick} data-id="element-152">
        <div className="flex items-center justify-between" data-id="element-153">
          <div className="flex items-center gap-4" data-id="element-154">
            <span className="text-3xl" data-id="element-155">{icon}</span>
            <span className="font-semibold text-navy text-base" data-id="element-156">{label}</span>
          </div>
          <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-teal-deep transition-colors" data-id="element-157" />
        </div>
      </Card>
    </motion.div>;
}